export const ROLES = [
  { id: "rol_zNs8sbmFwfH9HeSR", name: "admin", label: "管理者" },
  { id: "rol_vrFPVnj7RJhGtGN1", name: "approver", label: "承認者" },
  { id: "rol_EzExs5IcLTMXCL2C", name: "creator", label: "作成者" },
] as const;

export const roleColors: { [key: string]: { color: string; backgroundColor: string } } = {
  "rol_zNs8sbmFwfH9HeSR": { color: "#1a237e", backgroundColor: "#e8eaf6" }, // 管理者: インディゴ
  "rol_vrFPVnj7RJhGtGN1": { color: "#1b5e20", backgroundColor: "#e8f5e9" }, // 承認者: グリーン
  "rol_EzExs5IcLTMXCL2C": { color: "#e65100", backgroundColor: "#fff3e0" }, // 作成者: オレンジ
};

export const getRoleLabel = (roleId: string) => {
  const role = ROLES.find((r) => r.id === roleId);
  return role?.label ?? roleId;
};

export const getRoleLabels = (roleIds: string[]) => {
  return roleIds.map(getRoleLabel).join(", ");
};
